import { inject, Injectable } from "@angular/core";
import { EffectNotification, OnRunEffects } from "@ngrx/effects";
import { PcpDevtoolsService } from "../pcp-devtools.service";
import { Observable } from "rxjs";
import { IS_PRODUCTION } from "shared/util-runtime-config";

@Injectable()
export class RegisterDevtoolsEffects implements OnRunEffects {
    private readonly isProduction = inject(IS_PRODUCTION);
    private readonly devtools = inject(PcpDevtoolsService);

    ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
        if (!this.isProduction) {
             
            // @ts-expect-error
            window['PcpDevTools'] = this.devtools;
        }

        return resolvedEffects$;
    }
}
